import React, { useEffect, useState } from "react";
import UIBody from "../../../components/ui/UIBody";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../hooks/useApiCallHooks";

const RoboticsRegistration = () => {  
    const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  
  const [formData, setFormData] = useState({
  first_name: '',
  last_name: '',
  email: '',
  mobile_no: '',
  description: '',
  type: 'Robotic Syallbus'
});



  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit= (e) => {
    e.preventDefault();
    callAPI('post', 'add-contact-us', formData);
  };

  // Handle response
  useEffect(() => {
    if (responce?.data && statusCode === 200) {
      toast.success('Your message has been sent successfully!');
   
    }

    if (responce?.data && statusCode === 201) {
      toast.success('Contact created successfully!');
      setTimeout(() => {
        navigate('/');
      }, 1500);
    }

  }, [responce, statusCode, error, navigate]);  
    return (
        <UIBody
            content={
                <div className="container py-5">
                    <div className="text-center mb-4">
                        <h2>📌 Register for Robotics Program</h2>
                        <p className="text-muted">
                            Join our exciting robotics curriculum and start
                            building the future today! Fill out the form below
                            to secure your spot.
                        </p>
                    </div>

                    <div className="row">
                        {/* Form Card */}
                    <div className="col-lg-8 col-md-10 mx-auto mb-4">
  <div className="card shadow-lg border-0">
    <div className="card-header bg-primary text-white">
      <h5 className="mb-1 text-light">👩‍🎓 Student Registration</h5>
      <small>Please provide your details to get started</small>
    </div>
    <div className="card-body">
      <form className="account__form" onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="first-name">First Name</label>
              <input
                type="text"
                className="form-control"
                id="first-name"
                name="first_name"
                placeholder="First Name"
                value={formData.first_name}
                onChange={handleChange}
              />
              {error?.message === "ValidationError" && (
                <span className="text-danger small">{error?.data?.first_name}</span>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="last-name">Last Name</label>
              <input
                type="text"
                className="form-control"
                id="last-name"
                name="last_name"
                placeholder="Last Name"
                value={formData.last_name}
                onChange={handleChange}
              />
              {error?.message === "ValidationError" && (
                <span className="text-danger small">{error?.data?.last_name}</span>
              )}
            </div>
          </div>
        </div>

        <div className="form-group mt-3">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />
          {error?.message === "ValidationError" && (
            <span className="text-danger small">{error?.data?.email}</span>
          )}
        </div>

        <div className="form-group mt-3">
          <label htmlFor="mobile">Mobile No</label>
          <input
            type="number"
            className="form-control"
            id="mobile"
            name="mobile_no"
            placeholder="Mobile No"
            value={formData.mobile_no}
            onChange={handleChange}
          />
          {error?.message === "ValidationError" && (
            <span className="text-danger small">{error?.data?.mobile_no}</span>
          )}
        </div>

        <div className="form-group mt-3">
          <label htmlFor="description">Description</label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="2"
            placeholder="Write your message here..."
            value={formData.description}
            onChange={handleChange}
          ></textarea>
          {error?.message === "ValidationError" && (
            <span className="text-danger small">{error?.data?.description}</span>
          )}
        </div>

        <div className="form-group mt-3 d-none">
          <label htmlFor="type">Type</label>
          <input type="hidden" name="type" value={formData.type} />

        </div>

        <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary px-4 py-2 rounded-pill">
            Submit Request
          </button>
        </div>
      </form>
    </div>
  </div>
</div>


                        {/* Side Cards */}
                        <div className="col-lg-4">
                            <div className="card mb-4 border-success">
                                <div className="card-header robotical-regi-card text-white">
                                    ✅ What's Next?
                                </div>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item">
                                        🕒 We'll review your registration within
                                        24 hours
                                    </li>
                                    <li className="list-group-item">
                                        📞 Our team will contact you to discuss
                                        the program
                                    </li>
                                    <li className="list-group-item">
                                        🚀 Start your exciting robotics journey!
                                    </li>
                                </ul>
                            </div>

                            <div className="card border-warning">
                                <div className="card-header robotical-regi-card text-white">
                                    🎯 Program Benefits
                                </div>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item">
                                        🤖 Hands-on learning with real robots
                                    </li>
                                    <li className="list-group-item">
                                        👨‍🏫 Small class sizes for personalized
                                        attention
                                    </li>
                                    <li className="list-group-item">
                                        🧰 Industry-standard tools and kits
                                    </li>
                                    <li className="list-group-item">
                                        📜 Certificate upon completion
                                    </li>
                                    <li className="list-group-item">
                                        🧭 Career guidance and mentorship
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

export default RoboticsRegistration;
